import { Routes } from '@angular/router';
import { AuthGuard } from './Auth/AuthGaurd';
import { Page404Component } from './pages/Not-Found/page-404/page-404.component';
import { ComingSoonComponent } from './pages/Not-Found/coming-soon/coming-soon.component';
import { AuthRedirectGuard } from './Auth/AuthRedirectGuard';
import { PaymentApprovedComponent } from './pages/login-signup';

export const routes: Routes = [
  { path: 'not-found', component: Page404Component },
  { path: 'coming-soon', component: ComingSoonComponent },
  {
    path: 'payment/success',
    component: PaymentApprovedComponent,
    data: { title: 'Payment Success' },
  },
  // {
  //   path: '',
  //   loadChildren: () => import('./pages/Outer/outer.routes').then((m) => m.OuterRoutingModule),
  //   canActivate: [AuthRedirectGuard],
  // },
  {
    path: 'home',
    loadChildren: () => import('./pages/Layout/layout-routing').then((m) => m.LayoutRoutingModule),
    canActivate: [AuthGuard],
  },
  {
    path: '',
    loadChildren: () => import('./pages/Layout/layout-routing').then((m) => m.LayoutRoutingModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'auth',
    loadChildren: () => import('./pages/login-signup/loginsignup.module').then((m) => m.LoginSignupModule),
    canActivate: [AuthRedirectGuard],
  },



  // {
  //   path: '404',
  //   component: PageNotFoundComponent, // Ensure this component is correctly imported and declared
  // },
  // {
  //   path: '**',
  //   redirectTo: '/404', // Redirect to 404 page for unknown routes
  // },
];
